




















import { computed, defineComponent } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import useBalance from "@/hooks/useBalance";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import FormatMoney from "@/components/FormatMoney";
import SiteLogo from "@/components/SiteLogo";

export default defineComponent({
  name: "PageHeader",
  components: { FormatMoney, BaseIcon, SiteLogo, BaseButton },
  setup(_, { root }) {
    const { authUser, isMember } = useAuthUser();
    const { balance } = useBalance();

    const attrName = computed(() => (authUser.value ? "" : "href"));

    const balanceClick = () => {
      root.$router.push({ name: "balance" });
    };

    return { authUser, balance, isMember, balanceClick, attrName };
  },
});
